import React from 'react'
import { PatientPaymentForm } from './Payments'

/**
 * Component for displaying and managing patient payment form
 * Note: This component is maintained for backward compatibility
 * and uses the refactored PatientPaymentForm component internally
 * @param {Object} data - Initial data for the patient payment
 */
const PatientPaymentFormWrapper = ({ data }) => {
  return <PatientPaymentForm data={data} />
}

export default PatientPaymentFormWrapper
